// models component
import Ship from '@/models/Ship.js'
import SelectShip from '@/models/SelectShip'
import ShipLaborWork from '@/models/ShipLaborWork'
import ShipLaborAttendanceDaily from '@/models/ShipLaborAttendanceDaily'

export default class LaborTimelineDaily {
    static organizationId = ''

    // Ship Sailors Fetch
    static of(shipId, searchAt) {
        return Promise.resolve()
            .then(() => {
                return Ship.api()
                    .fetch()
                    .then((res) => {
                        this.organizationId =
                            res.entities.Ships[0].organizationId
                    })
            })
            .then(() => {
                return SelectShip.api().fetch(this.organizationId)
            })
            .then(() => {
                return ShipLaborWork.api().fetch(shipId)
            })
            .then(() => {
                return ShipLaborAttendanceDaily.api()
                    .fetch(shipId, searchAt, false)
                    .then((res) => {
                        // console.warn(res.entities.ShipLaborAttendanceDaily)
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
